/* guard to check if a user account has been deactivated by an administrator */

import {inject} from "@angular/core";
import {CanActivateFn} from "@angular/router";
import {UserService} from "../../services/user.service";
import {map, of, take} from "rxjs";

export const useractiveGuard: CanActivateFn = () => {
  const userService = inject(UserService);

  return of(userService.isActive()).pipe(
    take(1),
    map(useractive => {
      return !!useractive
    })
  )
};
